{"browse_shop":"Shop ansehen","go_to_shop":"Zum Shop gehen","no_orders_found":"Keine Bestellungen gefunden","title":"Bestellungen"}